import Icon from "@/components/elements/Icon";
import * as styles from "./styles.module.scss";

const Success = () => {
  return (
    <div className={styles.wrapper}>
      <Icon name="cacao_pod" className={styles.adornment} />

      <div>
        <h3>Thank You!</h3>

        <Icon name="success" className={styles.success} />

        <p>You have successfully subscribed to our newsletter!</p>
      </div>
    </div>
  );
};

export default Success;
